//
//
//
//
//
//
//
//
//

import HomeHero from '@/components/HomeHero'
import HomeHowTo from '@/components/HomeHowTo'
import HomeAR from '@/components/HomeAR'
import HomePrizes from '@/components/HomePrizes'
import HomeProducts from '@/components/HomeProducts'

export default {
  name: 'Home',
  components: {
    HomeHero,
    HomeHowTo,
    HomeAR,
    HomePrizes,
    HomeProducts,
  },
}
